import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Folder16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.5 4.25006C15.1904 4.25006 15.75 4.80971 15.75 5.50006V13.5001C15.75 14.1904 15.1904 14.7501 14.5 14.7501H1.5C0.809643 14.7501 0.25 14.1904 0.25 13.5001V2.50006C0.25 1.80971 0.809644 1.25006 1.5 1.25006H5.76581C6.13679 1.25006 6.4886 1.41484 6.72609 1.69983L8.85123 4.25L14.5 4.25006ZM1.75 4.25V2.75006H5.64872L6.89867 4.25L1.75 4.25ZM1.75 5.75V13.2501H14.25V5.75006C10.0833 5.75006 5.91667 5.75 1.75 5.75Z'
      fill='currentColor'
    />
  </Svg>
);

Folder16.displayName = 'Folder16';
export default Folder16;
